/**
 * Given a bit array of stuff, like IDs, that need some heavyish work done on
 * all of them, this function lets you batch that work into smaller chunks.
 */
export function batchWorkForArray<TArrayType, TReturnType>({
  fullList,
  batchSize = 250,
  work,
}: {
  fullList: TArrayType[];
  work: (batch: TArrayType[]) => TReturnType;
  batchSize?: number;
}): TReturnType[] {
  const batchReturns: TReturnType[] = [];

  for (let i = 0; i < fullList.length; i += batchSize) {
    const batch = fullList.slice(i, i + batchSize);
    batchReturns.push(work(batch));
  }

  return batchReturns;
}
